import { createRouter, createWebHistory } from 'vue-router';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Company from '../views/Company'
import ContactUs from '../views/ContactUs'
import ErrorPage from '../views/404'
import Services from '../views/Services'
import GrowthLeadership from '../views/services/GrowthLeadership'
import GrowthNavigation from '../views/services/GrowthNavigation'
import GrowthInflectionAnalysis from '../views/services/GrowthInflectionAnalysis'
import AIStabilizationAndGrowthFramework from '../views/services/AIStabilizationAndGrowthFramework'

const routes = [
    {
        path: '/',
        name: 'Company',
        component: Company,
        meta: {
            title: 'Green Hollow :: Navigating Growth Together',
        },
    },
    {
        path: '/contact',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
            title: 'Green Hollow :: Contact Us',
        },
    },
    {
        path: '/services',
        name: 'Servies',
        component: Services,
        meta: {
            title: 'Green Hollow :: Services',
        },
    },
    {
        path: '/services/growth-leadership',
        name: 'GrowthLeadership',
        component: GrowthLeadership,
        meta: {
            title: 'Green Hollow :: Services :: Growth Leadership',
        },
    },
    {
        path: '/services/growth-navigation',
        name: 'GrowthNavigation',
        component: GrowthNavigation,
        meta: {
            title: 'Green Hollow :: Services :: Growth Navigation',
        },
    },
    {
        path: '/services/growth-inflection-analysis',
        name: 'GrowthInflectionAnalysis',
        component: GrowthInflectionAnalysis,
        meta: {
            title: 'Green Hollow :: Services :: Growth Inflection Analysis',
        },
    },
    {
        path: '/services/ai-stabilization-and-growth-framework',
        name: 'AIStabilizationAndGrowthFramework',
        component: AIStabilizationAndGrowthFramework,
        meta: {
            title: 'Green Hollow :: Services :: AI Stabilization and Growth Framework',
        },
    },
    {
        path: '/error',
        name: 'Error',
        component: ErrorPage,
        meta: {
            title: 'Green Hollow :: Huh?  Not found...',
        },
    }
]

const router = createRouter({
    base: process.env.BASE_URL,
    history: createWebHistory(),
    routes: routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    AOS.init();
    next();
    window.scrollTo(0, 0)
});

export default router;
